module.exports = __webpack_public_path__ + "img/PIE_CHART.e0d6df91.svg";